const AreaCalendarType = {
  ForADynamicPeriod: 'forADynamicPeriod',
  ForAFixedPeriod: 'forAFixedPeriod',
}
  
module.exports = {
  AreaCalendarType,
}
